module.exports = __webpack_public_path__ + "img/grappled.dd337ec1.svg";